var map = {
	"./basic/Heading.vue": "8677",
	"./basic/Icon.vue": "62de",
	"./basic/Image.vue": "1d72",
	"./basic/Section.vue": "b648",
	"./basic/Video.vue": "b065",
	"./elements/Button.vue": "a0f4",
	"./elements/Countdown.vue": "ba2a",
	"./footer/Footer.vue": "4c03",
	"./form/Form.vue": "40b0",
	"./header/Header.vue": "a960"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a79";